/**
 * 多分栏登录：同一浏览器可并存超管 / 学生 / 机构 三条会话，各用独立 localStorage key。
 */
export const AUTH_PORTALS = ["super_admin", "student", "org"] as const;
export type AuthPortal = (typeof AUTH_PORTALS)[number];

const STORAGE_KEYS: Record<AuthPortal, string> = {
  super_admin: "token_super_admin",
  student: "token_student",
  org: "token_org",
};

export function getPortalToken(portal: AuthPortal): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEYS[portal]);
}

export function setPortalToken(portal: AuthPortal, token: string): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEYS[portal], token);
}

export function clearPortalToken(portal: AuthPortal): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEYS[portal]);
}

export function getTokenSuperAdmin(): string | null {
  return getPortalToken("super_admin");
}
export function getTokenStudent(): string | null {
  return getPortalToken("student");
}
export function getTokenOrg(): string | null {
  return getPortalToken("org");
}

export function clearTokenSuperAdmin(): void {
  clearPortalToken("super_admin");
}
export function clearTokenStudent(): void {
  clearPortalToken("student");
}
export function clearTokenOrg(): void {
  clearPortalToken("org");
}

export function authBearer(token: string | null | undefined): Record<string, string> {
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}
